import React from 'react';
import AboutSection from '../components/sections/About';

const About = () => {
  return (
    <div className="page-title">
      <div className="container">
        <div className="title-wrapper">
            <h1>About Us</h1>
            <p>Our story, mission, and what we bring to every engagement</p>
        </div>
      </div>
      <AboutSection />
    </div>
  );
};

export default About;
